import { Component, ojs, app } from "modular-openscriptjs";

const router = app("router");
const h = app("h");

export default class Logo extends Component {
	goHome() {
		return router.to("/");
	}

	render(...args) {
		return h.span(
			{ class: "d-block" },
			{ onclick: this.method("goHome") },
			h.img({
				loading: "lazy",
				src: "/assets/images/logo.png",
				alt: "Rato Logo",
				class: "logo-img",
			}, ...args)
		);
	}
}

ojs(Logo);
